var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 33.0001L24 2.00009C24 2.00009 31 1.81809 31 10.0001V25.0001H55C56.4657 24.9702 57.8851 25.5144 58.9551 26.5166C60.0252 27.5188 60.661 28.8995 60.727 30.3641C60.7229 31.6535 60.2575 32.8989 59.415 33.8751C60.3097 34.3997 61.0351 35.17 61.5049 36.0947C61.9747 37.0193 62.1693 38.0594 62.0654 39.0914C61.9616 40.1233 61.5638 41.1038 60.9192 41.9163C60.2746 42.7288 59.4103 43.3393 58.429 43.6751C58.9133 44.3899 59.2201 45.2099 59.3242 46.067C59.4282 46.9242 59.3265 47.7937 59.0273 48.6037C58.7282 49.4136 58.2403 50.1406 57.6041 50.7243C56.9678 51.308 56.2016 51.7316 55.369 51.9601C55.96 52.5235 56.3686 53.2512 56.5419 54.0492C56.7153 54.8471 56.6454 55.6787 56.3414 56.4366C56.0374 57.1944 55.5132 57.8438 54.8365 58.3007C54.1597 58.7577 53.3616 59.0013 52.545 59.0001H31C24.7687 59.1035 18.6011 57.733 13 55.0001",
    stroke: "#932091",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28H5C3.34315 28 2 29.3431 2 31V55C2 56.6569 3.34315 58 5 58H10C11.6569 58 13 56.6569 13 55V31C13 29.3431 11.6569 28 10 28Z",
    stroke: "#932091",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.edb362987e910927c3f276a0bcf5313c.svg";
export { ForwardRef as ReactComponent };